import React from 'react';
import { styled, css } from '@mui/material/styles';
import { Stack, Card, Button, Typography, Box } from '@mui/material';
import Link from 'next/link';
import { APP_ROUTES, ENTIRE_FRANCE_DISTANCE_MAX } from '@/src/constants';
import { useTranslation } from '@/src/i18n';

const CARDS_DATA = [
  {
    specialtyLabel: 'specialties-general-practitioner',
    specialtyShortName: 'medecin-generaliste',
    containerDataTestid: 'shortcut-card-general-practitioner',
    buttonDataTestid: 'teleconsult-general-practitioner-button',
  },
  {
    specialtyLabel: 'specialties-psychologist',
    specialtyShortName: 'psychologue',
    containerDataTestid: 'shortcut-card-psychologist',
    buttonDataTestid: 'teleconsult-psychologist-button',
  },
  {
    specialtyLabel: 'specialties-pediatrician',
    specialtyShortName: 'pediatre',
    containerDataTestid: 'shortcut-card-pediatrician',
    buttonDataTestid: 'teleconsult-pediatrician-button',
  },
];

const INITIAL_QUERY = {
  locality: '75001-PARIS',
  consultationModeFilter: 'TLC',
  distanceMax: ENTIRE_FRANCE_DISTANCE_MAX,
};

const CardsList = styled(Box)(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);

const CustomStack = styled(Stack)(
  ({ theme }) => css`
    overflow-x: scroll;
    padding: ${theme.spacing(3)};
    ::-webkit-scrollbar {
      display: none;
    }
  `,
);

const Item = styled(Card)(
  ({ theme }) => css`
    display: flex;
    border-radius: ${theme.spacing(1)};
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${theme.spacing(2)};
    min-width: ${theme.spacing(26)};
    ${theme.breakpoints.up('sm')} {
      max-width: ${theme.spacing(31)};
      width: ${theme.spacing(31)};
    }
  `,
);

const TlcShortcutsSection = () => {
  const { t } = useTranslation();

  return (
    <CardsList>
      <CustomStack direction="row" spacing={2}>
        {CARDS_DATA.map(card => (
          <Item
            key={card.specialtyShortName}
            data-testid={card.containerDataTestid}
          >
            <Typography align="center" sx={{ fontWeight: '500', flex: 1 }}>
              {t('Teleconsult-with-a')} {t(card.specialtyLabel)}
            </Typography>
            <Link
              href={{
                pathname: APP_ROUTES.SPECIALITY.LOCALITY,
                query: {
                  ...INITIAL_QUERY,
                  speciality: card.specialtyShortName,
                },
              }}
              passHref
              legacyBehavior
            >
              <Button
                color="primary"
                variant="contained"
                sx={{ mt: 2, alignItems: 'flex-end' }}
                data-testid={card.buttonDataTestid}
              >
                {t('teleconsult-btn')}
              </Button>
            </Link>
          </Item>
        ))}
      </CustomStack>
    </CardsList>
  );
};
export default TlcShortcutsSection;
